"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Deeplink = exports.DEEPLINK_EXPLANATIONS = exports.DEEPLINK_SCHEMAS = void 0;
exports.DEEPLINK_SCHEMAS = {
    story: "medics://story?m_id=%m_id%",
    feed: "medics://feed-open?m_id=%m_id%",
    document: "medics://document-open?m_id=%m_id%",
    search: "medics://global-search?m_tab=rcp&m_value=%m_value%",
    viewer: "medics://viewer?m_source=%m_source%&m_open_in=%m_open_in%",
    tasks: "medics://tasks",
    expert: "medics://expert",
    univers: "medics://universe",
    dbdownload: "medics://db-download",
    post: "medics://ad?m_id=%m_id%",
    application: "medics://application?m_source=%m_source%",
};
exports.DEEPLINK_EXPLANATIONS = {
    story: "Ouvrir une story",
    feed: "Ouvrir le fil d'un seul journal",
    document: "Ouvrir une fiche médiacament par ID",
    search: "Ouvrir la search sur la tab <xx> préremplie avec le mot <xx>",
    viewer: "Ouvrir n'importe quel URL dans l'appli",
    tasks: "Ouvrir mes todos",
    expert: "Ouvrir la fenêtre de validation expert",
    univers: "medics://universe",
    dbdownload: "Ouvrir l'appli vers le lien de téléchargement de la base",
    post: "Ouvrir un post visuel fix ou post vidéo",
    application: "Ouvrir un tool"
};
class Deeplink {
    constructor(data, params) {
        this.type = "link";
        this.deeplink = null;
        if (data) {
            this.type = data.type;
            if (params) {
                for (const key in params) {
                    this.deeplink = exports.DEEPLINK_SCHEMAS[this.type].replace(`%${key}%`, params[key]);
                }
            }
        }
    }
}
exports.Deeplink = Deeplink;
//# sourceMappingURL=Deeplink.js.map